import { Content, ContentInstructions } from '../../../types';
import { DataOptionsFactory } from '../data/options';

export type ContentOptions = {
  data?: DataOptionsFactory;
  instructions?: ContentInstructions;
};

export class ContentFactory {
  type: string;
  data?: DataOptionsFactory;
  instructions?: ContentInstructions;

  /**
   *
   * @param type
   * @param options
   */
  constructor(type: string, options: ContentOptions = {}) {
    this.type = type;
    this.data = options.data;
    this.instructions = options.instructions;
  }

  _build(): Content {
    const content: Content = {
      type: this.type,
      instructions: this.instructions,
    };

    if (this.data) {
      content.dataOptions = this.data._build();
    }

    return content;
  }
}
